module.exports = __webpack_public_path__ + "img/4.663126fb.png";